import { render } from "./StaffTripCalendar.vue?vue&type=template&id=0d67599a&scoped=true"
import script from "./StaffTripCalendar.vue?vue&type=script&lang=js"
export * from "./StaffTripCalendar.vue?vue&type=script&lang=js"

import "./StaffTripCalendar.vue?vue&type=style&index=0&id=0d67599a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d67599a"

export default script